import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('localizacaoacessos');

export const check = () => useBasicAuth.checkToken();

export const findLocalizacaoAcessosById = (id) => 
  axios.get(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllLocalizacaoAcessos = () => 
  axios.get(urlAPI + "/findAll" , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllLocalizacaoAcessosByDeleted = (value) => 
  axios.get(urlAPI + "/deleted/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  }); 

export const findAllLocalizacaoAcessosByEnabled = (value) => 
  axios.get(urlAPI + "/enabled/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  }); 

export const addLocalizacaoAcessos = (obj) => 
  axios.post(urlAPI + "/addLocalizacaoAcessos", JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const updateLocalizacaoAcessos = (obj) => 
  axios.put(urlAPI + "/updateLocalizacaoAcessos/" + obj.localizacaoAcessos.id, JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const deleteLocalizacaoAcessos = (id) => 
  axios.delete(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });



  //CLIMA_CIDADE
export const findAllByLocalizacaoAcessosCidade_localizacaoAcessos = (localizacaoAcessos) => 
axios.post(urlAPI + "/localizacaoAcessoscidade/localizacaoAcessos", JSON.stringify(localizacaoAcessos), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});

export const findAllByLocalizacaoAcessosCidade_cidade = (cidade) => 
axios.post(urlAPI + "/localizacaoAcessoscidade/cidade", JSON.stringify(cidade), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});

export const findAllByLocalizacaoAcessosCidade = (localizacaoAcessos, cidade) => {
let requestObj = {
  localizacaoAcessos: localizacaoAcessos,
  cidade: cidade
}
axios.post(urlAPI + "/localizacaoAcessoscidade", JSON.stringify(requestObj), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});
}


//CLIMA_ESTADO
export const findAllByLocalizacaoAcessosEstado_localizacaoAcessos = (localizacaoAcessos) => 
axios.post(urlAPI + "/localizacaoAcessosestado/localizacaoAcessos", JSON.stringify(localizacaoAcessos), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});

export const findAllByLocalizacaoAcessosEstado_estado = (estado) => 
axios.post(urlAPI + "/localizacaoAcessosestado/estado", JSON.stringify(estado), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});

export const findAllByLocalizacaoAcessosEstado = (localizacaoAcessos, estado) => {
let requestObj = {
  localizacaoAcessos: localizacaoAcessos,
  estado: estado
}
axios.post(urlAPI + "/localizacaoAcessosestado", JSON.stringify(requestObj), environment.HEADER)
.then(({data}) => data)
.catch(e => {
  useBasicAuth.handleError(e);
});
}